"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
/** @jsxFrag React.Fragment */
const react_1 = require("react");
const b_1 = __importDefault(require("b_"));
const react_redux_1 = require("react-redux");
const pythia_libs_1 = require("@yandex-int/pythia-libs");
const actions_1 = require("src/redux/actions");
const color_logic_1 = require("./color-logic");
const types_1 = require("./types");
const b = b_1.default.with('header');
function ScrollPanelLabels({ pages, pagesToDisplay, labelRefs }) {
    var _a;
    const i18n = (0, pythia_libs_1.i18n)(['labels']);
    let groupIndex = -1;
    let pageDisplayNumber = 0;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (_a = pages === null || pages === void 0 ? void 0 : pages.pageOrderWithRotation) === null || _a === void 0 ? void 0 : _a.map(group => {
            if ((0, types_1.isPageOrderGroup)(group)) {
                groupIndex += 1;
                const groupToDisplay = group.pages.filter(page => pagesToDisplay.has(page));
                if (!groupToDisplay.length) {
                    pageDisplayNumber += group.pages.length;
                }
                return groupToDisplay.length > 0 ? ((0, jsx_runtime_1.jsx)(react_1.Fragment, { children: (0, jsx_runtime_1.jsxs)(GroupWrapper, Object.assign({ index: groupIndex }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: b('rotation-group-label') }, { children: `${i18n(['rotationGroup'])} ${groupIndex + 1}` })), groupToDisplay.map(page => {
                                pageDisplayNumber += 1;
                                return ((0, jsx_runtime_1.jsx)(Label, { idx: pageDisplayNumber, currentPage: pages.currentPage, id: page, labelRefs: labelRefs }, page));
                            })] })) }, pageDisplayNumber)) : null;
            }
            pageDisplayNumber += 1;
            if (!pagesToDisplay.has(group))
                return null;
            return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'wrapper2', style: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginRight: '4px'
                } }, { children: (0, jsx_runtime_1.jsx)(Label, { idx: pageDisplayNumber, currentPage: pages.currentPage, id: group, labelRefs: labelRefs }, group) }), pageDisplayNumber));
        }) }));
}
exports.default = ScrollPanelLabels;
function Label({ currentPage, idx, id, labelRefs }) {
    const dispatch = (0, react_redux_1.useDispatch)();
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ id: `page${id}`, className: b('label-wrapper'), ref: element => (labelRefs.current[idx] = element) }, { children: (0, jsx_runtime_1.jsx)("button", Object.assign({ onClick: () => dispatch((0, actions_1.setCurrentPage)(idx - 1)), className: b('label', {
                isCurrent: currentPage === idx - 1
            }) }, { children: idx })) })));
}
function GroupWrapper({ children, index }) {
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ style: (0, color_logic_1.getGroupLabelStyle)(index), className: b('rotation-group') }, { children: children })));
}
